/**
 * Recipient-picker rules shared by both group mailings (задача ERP #67):
 * the SendGrid composer (ТЗ 0015) and the communicator broadcast (ТЗ 0003).
 *
 * Both pickers got a «включая закрытые договоры» switch. Turning it OFF makes
 * rows disappear, and a ticked id that is no longer on screen must not stay
 * selected — otherwise the counter lies and the broadcast (which sends the raw
 * selection) would still reach a student the operator can no longer see.
 */

/**
 * Drop selected ids that are no longer offered. Never ADDS ids — manual
 * un-checks survive — and returns the SAME Set instance when nothing was
 * removed, so a `setState(prev => pruneSelection(prev, ids))` on every
 * background refetch does not re-render.
 */
export const pruneSelection = (
  selected: Set<string>,
  offeredIds: Iterable<string>,
): Set<string> => {
  const offered = new Set(offeredIds);
  let changed = false;
  const next = new Set<string>();
  selected.forEach((id) => {
    if (offered.has(id)) next.add(id);
    else changed = true;
  });
  return changed ? next : selected;
};

export interface ICommsRosterRow {
  terminated: boolean;
  unread: number;
}

/**
 * Which communicator roster rows are shown.
 *
 * Default (`includeTerminated = false`) is the communicator's long-standing
 * rule: a student whose every agreement in the group is closed is hidden,
 * unless they still have something unread. With the switch ON the broadcast
 * offers the whole roster. Order is preserved.
 */
export const filterCommsStudents = <T extends ICommsRosterRow>(
  rows: T[],
  includeTerminated = false,
): T[] =>
  includeTerminated
    ? rows
    : rows.filter((entry) => !entry.terminated || entry.unread > 0);
